// Who is responsible for personal information on this portal, for the Privacy Policy, Terms of Use and Cookie Policy
// (/privacy, /terms, /cookies; text in ./policies.js). Fill in the agency's contact details and its Data Protection
// Officer before relying on the pages: empty values are left out and the pages point to the agency's offices instead.

const operator = {
  name: "Hayok Medicare", // registered company name and RC number, if they should appear
  email: "support@hayokmedicare.ng",
};

export default {
  platform: "Claimify",
  operator,
  portal: "the KGSHIA portal",
  portalTitle: "KGSHIA Portal",
  agency: {
    name: "Kogi State Health Insurance Agency",
    short: "KGSHIA",
    state: "Kogi State",
    website: "",
    dpoEmail: "", // Data Protection Officer
    email: "",
    phone: "",
    address: "",
  },
  governingLaw: "the laws of the Federal Republic of Nigeria and of Kogi State",
};
